var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuperiorAssured(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.347 6.00946C2.73432 6.62214 2.73432 7.6155 3.347 8.22818L9.33754 14.2187L11.5563 12L5.56572 6.00946C4.95303 5.39678 3.95968 5.39678 3.347 6.00946Z",
    fill: "#0067E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.45951 10.4469C1.84683 11.0596 1.84683 12.0529 2.45951 12.6656L6.67508 16.8812L8.89379 14.6625L4.67823 10.4469C4.06555 9.83422 3.07219 9.83421 2.45951 10.4469Z",
    fill: "#0067E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9905 3.347C17.3779 2.73432 16.3845 2.73432 15.7718 3.347L9.78128 9.33754L12 11.5563L17.9905 5.56572C18.6032 4.95303 18.6032 3.95968 17.9905 3.347Z",
    fill: "#0067E2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5531 2.45951C12.9404 1.84683 11.9471 1.84683 11.3344 2.45951L7.11882 6.67508L9.33754 8.89379L13.5531 4.67823C14.1658 4.06555 14.1658 3.07219 13.5531 2.45951Z",
    fill: "#0067E2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.653 17.9905C21.2657 17.3779 21.2657 16.3845 20.653 15.7718L14.6625 9.78128L12.4437 12L18.4343 17.9905C19.047 18.6032 20.0403 18.6032 20.653 17.9905Z",
    fill: "#0067E2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5405 13.5531C22.1532 12.9404 22.1532 11.9471 21.5405 11.3344L17.3249 7.11882L15.1062 9.33754L19.3218 13.5531C19.9345 14.1658 20.9278 14.1658 21.5405 13.5531Z",
    fill: "#0067E2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00946 20.653C6.62214 21.2657 7.6155 21.2657 8.22818 20.653L14.2187 14.6625L12 12.4437L6.00946 18.4343C5.39678 19.047 5.39678 20.0403 6.00946 20.653Z",
    fill: "#0067E2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4469 21.5405C11.0596 22.1532 12.0529 22.1532 12.6656 21.5405L16.8812 17.3249L14.6625 15.1062L10.4469 19.3218C9.83421 19.9345 9.83421 20.9278 10.4469 21.5405Z",
    fill: "#0067E2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperiorAssured);
export default __webpack_public_path__ + "static/media/superiorAssured.2fd17e1f8d4290de1d1c8129411f15d5.svg";
export { ForwardRef as ReactComponent };